import { StaticImageData } from 'next/image';

import FocusImg from '@/assets/img/metra/gallery-focus.png';
import WidgetsImg from '@/assets/img/metra/gallery-widgets.png';
import LockscreenImg from '@/assets/img/metra/gallery-lockscreen.png';
import TwoMoodsImg from '@/assets/img/metra/gallery-two-moods.png';
import SwipeImg from '@/assets/img/metra/gallery-swipe.png';
import BreakImg from '@/assets/img/metra/gallery-break.png';

export type Feature = {
  n: string;
  label: string;
  title: string;
  body: string;
  img: StaticImageData;
  alt: string;
  pos: string;
  phone: boolean;
};

export const FEATURES: Feature[] = [
  {
    n: '01',
    label: 'Zero setup',
    title: 'Swipe to start',
    body: "No modals, no setup. Slide the pill to the top and you're in a session.",
    img: SwipeImg,
    alt: 'Metra swipe-to-start gesture',
    pos: '50% 100%',
    phone: true,
  },
  {
    n: '02',
    label: 'Built-in boundaries',
    title: 'Focus mode',
    body: 'Blocks distracting apps automatically for as long as a timer is running.',
    img: FocusImg,
    alt: 'Metra Focus Mode blocking distracting apps',
    pos: '50% 50%',
    phone: true,
  },
  {
    n: '03',
    label: 'One-tap access',
    title: 'Home widgets',
    body: "Small or Medium — pick what fits your home screen. Tap once and it's running.",
    img: WidgetsImg,
    alt: 'Metra home screen widgets',
    pos: '50% 50%',
    phone: false,
  },
  {
    n: '04',
    label: 'Always visible',
    title: 'Lock screen live activity',
    body: 'The countdown sits above your wallpaper — pause or reset without unlocking.',
    img: LockscreenImg,
    alt: 'Metra Live Activity on the lock screen',
    pos: '50% 100%',
    phone: true,
  },
  {
    n: '05',
    label: 'Built-in recovery',
    title: 'Step away, return ready',
    body: 'When a session ends, take a five-minute break — reset, then jump back in.',
    img: BreakImg,
    alt: 'Metra completed work session with a five-minute break option',
    pos: '50% 0%',
    phone: true,
  },
  {
    n: '06',
    label: 'At home on iPhone',
    title: 'Light and dark, done right',
    body: 'Two tuned moods that follow your system appearance, automatically.',
    img: TwoMoodsImg,
    alt: 'Metra light and dark themes',
    pos: '50% 0%',
    phone: true,
  },
];
